import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { makeStyles, Tabs, Tab, Paper, CircularProgress, Typography } from "@material-ui/core";
import api from "../../services/api";
import ChatsView from "./ChatsView";

const useStyles = makeStyles((theme) => ({
  shell: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100% - 48px)",
    width: "100%",
    minHeight: 0,
  },
  tabsBar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  body: {
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
    display: "flex",
  },
  gate: {
    height: "calc(100% - 48px)",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#666",
  },
}));

const TOOLS = [
  { key: "chats", label: "Chats Internos", render: (token) => <ChatsView token={token} /> },
  // adicionar novas ferramentas aqui
];

const OwnerTools = () => {
  const classes = useStyles();
  const { token } = useParams();
  const [tab, setTab] = useState(0);
  const [status, setStatus] = useState("checking"); // checking | ok | denied

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        await api.get("/internal-chat-view/companies", {
          headers: { "X-Ownerview-Token": token || "" },
        });
        if (active) setStatus("ok");
      } catch {
        if (active) setStatus("denied");
      }
    })();
    return () => {
      active = false;
    };
  }, [token]);

  if (status === "checking") {
    return (
      <div className={classes.gate}>
        <CircularProgress size={24} />
      </div>
    );
  }

  if (status === "denied") {
    return (
      <div className={classes.gate}>
        <Typography variant="h6">Not Found</Typography>
      </div>
    );
  }

  const active = TOOLS[tab];

  return (
    <div className={classes.shell}>
      <Paper square className={classes.tabsBar} elevation={0}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
        >
          {TOOLS.map((t) => (
            <Tab key={t.key} label={t.label} />
          ))}
        </Tabs>
      </Paper>
      <div className={classes.body}>{active?.render(token)}</div>
    </div>
  );
};

export default OwnerTools;
